import PropTypes from 'prop-types';

export const ApiKeyProps = PropTypes.shape({
  externalId: PropTypes.string,
  apiKey: PropTypes.string,
  orgId: PropTypes.string,
  writeAccess: PropTypes.bool,
  adminAccess: PropTypes.bool,
  locked: PropTypes.bool
});

export const ApiKeyDefaults = {
  externalId: '',
  apiKey: '',
  orgId: '',
  writeAccess: false,
  adminAccess: false,
  locked: false
};
